unable to read source [project]/repos/src/scraping/csv/csv.ts